var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackerPackedOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#cecece",
    transform: "translate(-480 -4291) translate(480 4291)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    stroke: "#f2f2f2",
    strokeWidth: "0.5px",
    d: "M350.5-19.646a.787.787 0 0 0-.65-.354h-7.526a.739.739 0 0 0-.677.429l-.426.834h-2.81l-.427-.834a.755.755 0 0 0-.677-.429H323.76a.787.787 0 0 0-.652.354.761.761 0 0 0-.025.733l2.433 4.9v12.455a.742.742 0 0 0 .753.758h21.073a.742.742 0 0 0 .753-.758v-12.455l2.433-4.9a.836.836 0 0 0-.028-.733zm-25.513 1.162h11.866l1.756 3.537h-11.864zm14.076 16.168h-12.042v-11.116h12.042zm.1-14.905h1.33l-.677 1.339zm7.426 14.905h-6.021v-11.116h6.021zm.276-12.632h-5.82l1.756-3.537h5.845z",
    transform: "translate(-480 -4291) translate(165.5 4322.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerPackedOff);
export default __webpack_public_path__ + "static/media/tracker-packed-off.c39e405f741c66d1884275fc7e7300f4.svg";
export { ForwardRef as ReactComponent };